import * as ProgressBar from "progressbar.js";

export default class Parking {
  constructor() {
    this.parkings = [];
    this.neighborhoods = [];
    this.geolocate = document.querySelector('#geolocate');
    this.sort = null;
    this.init();
  }

  init() {
    this.initViewToggle();

    jQuery.getJSON('/parking/data.json', function (data) {
      this.parkings = data.parking;
      this.neighborhoods = data.neighborhood;

      this.setParking();
      this.setNeighborhood();
      this.setFilter();
      this.sortByDistance();
      this.initDetailMap();

    }.bind(this));
  }

  initViewToggle() {
    let toggleButtons = document.querySelectorAll('.parking-view-toggle .btn-toggle');
    let listContent = document.querySelector('.parking-list-content');
    let mapWrapper = document.querySelector('.parking-map-wrapper');
    let mapInitialized = false;

    let activeClasses = ['tw:bg-blue-500', 'tw:text-white'];
    let inactiveClasses = ['tw:bg-transparent', 'tw:text-blue-500'];

    if (!toggleButtons.length || !listContent || !mapWrapper) return;

    toggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleButtons.forEach(function (b) {
          b.classList.remove('active', ...activeClasses);
          b.classList.add(...inactiveClasses);
        });
        btn.classList.add('active', ...activeClasses);
        btn.classList.remove(...inactiveClasses);

        let view = btn.getAttribute('data-view');

        if (view === 'map') {
          listContent.style.display = 'none';
          mapWrapper.style.display = 'block';

          if (!mapInitialized) {
            mapInitialized = true;
            this.initMap();
          }
        } else {
          listContent.style.display = '';
          mapWrapper.style.display = 'none';
        }
      }.bind(this));
    }.bind(this));
  }

  collectParkingNodes() {
    let nodes = [];
    document.querySelectorAll('.parking-teaser-wide').forEach(function (el) {
      let link = el.closest('a');
      nodes.push({
        id: el.dataset.id,
        title: el.dataset.title || el.dataset.name,
        latitude: parseFloat(el.dataset.latitude),
        longitude: parseFloat(el.dataset.longitude),
        neighborhood: el.dataset.neighborhood,
        image: el.dataset.image || '',
        hours: el.dataset.hours || '',
        url: link ? link.getAttribute('href') : ''
      });
    });
    return nodes;
  }

  loadArcGIS() {
    return new Promise(function (resolve, reject) {
      if (window.require && window.require.defined && window.require.defined('esri/Map')) {
        resolve();
        return;
      }

      let css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://js.arcgis.com/4.29/esri/themes/light/main.css';
      document.head.appendChild(css);

      let script = document.createElement('script');
      script.src = 'https://js.arcgis.com/4.29/';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  initMap() {
    let self = this;
    let nodes = this.collectParkingNodes();

    this.loadArcGIS().then(function () {
      window.require([
        'esri/config',
        'esri/Map',
        'esri/WebMap',
        'esri/Basemap',
        'esri/layers/TileLayer',
        'esri/views/MapView',
        'esri/Graphic',
        'esri/layers/GraphicsLayer',
        'esri/symbols/PictureMarkerSymbol',
        'esri/geometry/Point'
      ], function (esriConfig, Map, WebMap, Basemap, TileLayer, MapView, Graphic, GraphicsLayer, PictureMarkerSymbol, Point) {

        let layer = new GraphicsLayer();

        // Try VDL portal basemap, fallback to Esri public
        esriConfig.portalUrl = 'https://maps.vdl.lu/portal';

        let webmap = new WebMap({
          portalItem: { id: '64e7e7871f9645fcb95f45abe1c2ae3d' }
        });

        webmap.loadAll().then(function () {
          // Move reference layers (labels) into baseLayers so markers render on top
          webmap.basemap.baseLayers.addMany(webmap.basemap.referenceLayers);
          webmap.basemap.referenceLayers.removeAll();
          webmap.add(layer);

          self.createMapView(webmap, layer, nodes, Map, MapView, Graphic, GraphicsLayer, PictureMarkerSymbol, Point);

        }).catch(function () {
          // CORS blocked (localhost) — fallback to Esri public basemap
          console.log('VDL portal unavailable, using Esri public basemap');

          let grayBase = new TileLayer({
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer'
          });
          let grayLabels = new TileLayer({
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer'
          });

          var map = new Map({
            basemap: new Basemap({ baseLayers: [grayBase] }),
            layers: [grayLabels, layer]
          });

          self.createMapView(map, layer, nodes, Map, MapView, Graphic, GraphicsLayer, PictureMarkerSymbol, Point);
        });

      });
    });
  }

  addFullscreenButton(containerId) {
    let mapEl = document.getElementById(containerId);
    let wrapper = mapEl ? mapEl.closest('.iframe-map') : null;
    if (!wrapper) return;

    let fullscreenBtn = document.createElement('a');
    fullscreenBtn.href = '#';
    fullscreenBtn.className = 'fullscreen-button';
    fullscreenBtn.textContent = 'Agrandir la carte';
    fullscreenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      wrapper.classList.add('fullscreen');
    });

    let closeBtn = document.createElement('a');
    closeBtn.href = '#';
    closeBtn.className = 'fullscreen-close-button';
    closeBtn.textContent = 'Reduire la carte';
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      wrapper.classList.remove('fullscreen');
    });

    wrapper.insertBefore(closeBtn, mapEl);
    wrapper.appendChild(fullscreenBtn);
  }

  createMapView(map, layer, nodes, Map, MapView, Graphic, GraphicsLayer, PictureMarkerSymbol, Point) {
    let self = this;
    this.addFullscreenButton('parking-map');

    let view = new MapView({
      container: 'parking-map',
      map: map,
      center: [6.13, 49.61],
      zoom: 13,
      constraints: { maxZoom: 20, snapToZoom: true },
      navigation: {
        mouseWheelZoomEnabled: false
      },
      popup: {
        dockEnabled: false,
        collapseEnabled: false,
        actions: []
      }
    });

    view.when(function () {
      view.popup.actions = [];
      view.popup.dockOptions = { buttonEnabled: false };

      var mapContainer = document.getElementById('parking-map');
      var observer = new MutationObserver(function () {
        mapContainer.querySelectorAll('calcite-flow-item').forEach(function (item) {
          if (item.shadowRoot && !item.shadowRoot.querySelector('.parking-popup-fix')) {
            var style = document.createElement('style');
            style.className = 'parking-popup-fix';
            style.textContent = '.header { border-block-end: none !important; }';
            item.shadowRoot.appendChild(style);
          }
        });
      });
      observer.observe(mapContainer, { childList: true, subtree: true });

      nodes.forEach(function (node) {
        if (!node.latitude || !node.longitude) return;

        let realtime = null;
        for (let i = 0; i < self.parkings.length; i++) {
          if (self.parkings[i].id == node.id) {
            realtime = self.parkings[i];
            break;
          }
        }

        let available = realtime ? realtime.actuel : 0;
        let total = realtime ? realtime.total : 0;
        let isOpen = realtime ? realtime.ouvert : 0;
        let hasData = isOpen && total > 0;
        let ratio = hasData ? (total - available) / total : 0;
        let color = hasData ? self.getMarkerColor(available, total) : null;

        let svgUrl = self.buildMarkerSvg(ratio, color);

        let symbol = new PictureMarkerSymbol({
          url: svgUrl,
          width: 32,
          height: 32
        });

        let point = new Point({
          longitude: node.longitude,
          latitude: node.latitude
        });

        let imageHtml = node.image
          ? '<div style="margin-top:8px;"><img src="' + node.image + '" alt="' + node.title + '" style="max-width:250px;max-height:150px;object-fit:cover;border-radius:4px;"></div>'
          : '';

        let availabilityHtml = total > 0
          ? '<div style="margin-top:4px;color:#666;">' + available + ' places libres / ' + total + '</div>'
          : (isOpen ? '<div style="margin-top:4px;color:#666;">Pas de données</div>' : '<div style="margin-top:4px;color:#666;">Fermé</div>');

        let popupContent = '<div style="font-family:sans-serif;">'
          + (node.hours ? '<div style="color:#666;">' + node.hours + '</div>' : '')
          + availabilityHtml
          + imageHtml
          + '</div>';

        let graphic = new Graphic({
          geometry: point,
          symbol: symbol,
          attributes: node,
          popupTemplate: {
            title: '<a href="' + node.url + '" style="color:#1E3368;text-decoration:none;font-weight:bold;">' + node.title + '</a>',
            content: popupContent,
            actions: [],
            overwriteActions: true
          }
        });

        layer.add(graphic);
      });
    });
  }

  buildMarkerSvg(ratio, color) {
    let size = 64;
    let cx = size / 2;
    let cy = size / 2;
    let r = 26;
    let strokeWidth = 5;
    let circumference = 2 * Math.PI * r;
    let arcLength = circumference * Math.min(ratio, 1);
    let gap = circumference - arcLength;

    // SVG: white circle + grey track + colored arc + "P" text
    let svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">'
      // Drop shadow
      + '<filter id="s"><feDropShadow dx="0" dy="1" stdDeviation="1" flood-opacity="0.06"/></filter>'
      // White circle background with white border
      + '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r + strokeWidth / 2 + 4) + '" fill="white" filter="url(#s)"/>'
      // Grey track
      + '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="#E8E8E8" stroke-width="' + strokeWidth + '"/>'
      // Colored arc (occupation) - only if color provided
      + (color
        ? '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + color + '" stroke-width="' + strokeWidth + '"'
          + ' stroke-dasharray="' + arcLength + ' ' + gap + '"'
          + ' stroke-linecap="round"'
          + ' transform="rotate(-90 ' + cx + ' ' + cy + ')"/>'
        : '')
      // "P" letter
      + '<text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" dominant-baseline="central" font-family="sans-serif" font-weight="300" font-size="26" fill="#1E3368">P</text>'
      + '</svg>';

    return 'data:image/svg+xml;base64,' + btoa(svg);
  }

  initDetailMap() {
    let container = document.getElementById('parking-detail-map');
    let accessList = document.querySelector('.parking-access-list');
    if (!container || !accessList) return;

    let parkingId = accessList.dataset.parkingId;
    let lat = parseFloat(accessList.dataset.latitude);
    let lng = parseFloat(accessList.dataset.longitude);

    // Find parking data with entries/exits
    let parkingData = null;
    for (let i = 0; i < this.parkings.length; i++) {
      if (this.parkings[i].id == parkingId) {
        parkingData = this.parkings[i];
        break;
      }
    }

    if (!parkingData) return;

    let entrees = parkingData.entrees || [];
    let sorties = parkingData.sorties || [];

    // Build access list HTML
    let html = '';
    entrees.forEach(function (e) {
      var gps = (e.latitude && e.longitude) ? e.latitude + ', ' + e.longitude : '';
      html += '<div class="tw:flex tw:items-start tw:gap-3 tw:mb-4">'
        + '<span class="tw:inline-flex tw:items-center tw:justify-center tw:w-7 tw:h-7 tw:rounded-full tw:bg-green-500 tw:text-white tw:text-xs tw:font-bold tw:shrink-0">' + e.index + '</span>'
        + '<div><p class="tw:text-xs tw:uppercase tw:text-gray-400 tw:font-bold tw:mb-0.5">Entr\u00e9e</p>'
        + '<p class="tw:font-bold tw:text-sm">' + e.adresse + '</p>'
        + (gps ? '<p class="tw:text-xs tw:text-gray-400">GPS: ' + gps + '</p>' : '')
        + '</div></div>';
    });
    sorties.forEach(function (s) {
      var mainLine = s.direction ? 'Direction ' + s.direction : s.adresse;
      html += '<div class="tw:flex tw:items-start tw:gap-3 tw:mb-4">'
        + '<span class="tw:inline-flex tw:items-center tw:justify-center tw:w-7 tw:h-7 tw:rounded-full tw:bg-red-500 tw:text-white tw:text-xs tw:font-bold tw:shrink-0">' + s.index + '</span>'
        + '<div><p class="tw:text-xs tw:uppercase tw:text-gray-400 tw:font-bold tw:mb-0.5">Sortie</p>'
        + '<p class="tw:font-bold tw:text-sm">' + mainLine + '</p>'
        + '</div></div>';
    });
    accessList.innerHTML = html;

    // Build the map
    let self = this;
    this.loadArcGIS().then(function () {
      window.require([
        'esri/config',
        'esri/Map',
        'esri/WebMap',
        'esri/Basemap',
        'esri/layers/TileLayer',
        'esri/views/MapView',
        'esri/Graphic',
        'esri/layers/GraphicsLayer',
        'esri/symbols/SimpleMarkerSymbol',
        'esri/symbols/TextSymbol',
        'esri/geometry/Point'
      ], function (esriConfig, Map, WebMap, Basemap, TileLayer, MapView, Graphic, GraphicsLayer, SimpleMarkerSymbol, TextSymbol, Point) {

        let layer = new GraphicsLayer();

        esriConfig.portalUrl = 'https://maps.vdl.lu/portal';
        let webmap = new WebMap({ portalItem: { id: '64e7e7871f9645fcb95f45abe1c2ae3d' } });

        webmap.loadAll().then(function () {
          webmap.basemap.baseLayers.addMany(webmap.basemap.referenceLayers);
          webmap.basemap.referenceLayers.removeAll();
          webmap.add(layer);
          return webmap;
        }).catch(function () {
          console.log('VDL portal unavailable, using Esri fallback');
          let grayBase = new TileLayer({ url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer' });
          let grayLabels = new TileLayer({ url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer' });
          let map = new Map({ basemap: new Basemap({ baseLayers: [grayBase] }), layers: [grayLabels, layer] });
          return map;
        }).then(function (map) {

        self.addFullscreenButton('parking-detail-map');

        let view = new MapView({
          container: 'parking-detail-map',
          map: map,
          center: [lng, lat],
          zoom: 17,
          constraints: { maxZoom: 20, snapToZoom: true },
          navigation: { mouseWheelZoomEnabled: false },
          popup: { dockEnabled: false, collapseEnabled: false, actions: [] }
        });

        view.when(function () {
          view.popup.actions = [];
          view.popup.dockOptions = { buttonEnabled: false };

          var mapContainer = document.getElementById('parking-detail-map');
          var observer = new MutationObserver(function () {
            mapContainer.querySelectorAll('calcite-flow-item').forEach(function (item) {
              if (item.shadowRoot && !item.shadowRoot.querySelector('.parking-popup-fix')) {
                var style = document.createElement('style');
                style.className = 'parking-popup-fix';
                style.textContent = '.header { border-block-end: none !important; }';
                item.shadowRoot.appendChild(style);
              }
            });
          });
          observer.observe(mapContainer, { childList: true, subtree: true });

          // Parking marker with occupation
          let available = parkingData.actuel || 0;
          let total = parkingData.total || 0;
          let isOpen = parkingData.ouvert || 0;
          let hasData = isOpen && total > 0;
          let ratio = hasData ? (total - available) / total : 0;
          let color = hasData ? self.getMarkerColor(available, total) : null;
          let svgUrl = self.buildMarkerSvg(ratio, color);

          window.require(['esri/symbols/PictureMarkerSymbol'], function (PictureMarkerSymbol) {
            layer.add(new Graphic({
              geometry: new Point({ longitude: lng, latitude: lat }),
              symbol: new PictureMarkerSymbol({ url: svgUrl, width: 32, height: 32 })
            }));
          });

          // Entry markers (green numbered circles)
          entrees.forEach(function (e) {
            if (!e.latitude || !e.longitude) return;
            var entreePopup = {
              title: 'Entrée ' + e.index,
              content: '<div style="font-family:sans-serif;color:#666;">' + e.adresse + '</div>',
              actions: [], overwriteActions: true
            };
            layer.add(new Graphic({
              geometry: new Point({ longitude: e.longitude, latitude: e.latitude }),
              symbol: new SimpleMarkerSymbol({ style: 'circle', size: 22, color: '#2DA86A', outline: { color: 'white', width: 2 } }),
              popupTemplate: entreePopup
            }));
            layer.add(new Graphic({
              geometry: new Point({ longitude: e.longitude, latitude: e.latitude }),
              symbol: new TextSymbol({ text: '' + e.index, color: 'white', font: { size: 10, weight: 'bold' }, yoffset: -1.5 })
            }));
          });

          // Exit markers (red numbered circles)
          sorties.forEach(function (s) {
            if (!s.latitude || !s.longitude) return;
            var sortieContent = '<div style="font-family:sans-serif;color:#666;">' + s.adresse
              + (s.direction ? '<br>&rsaquo; ' + s.direction : '') + '</div>';
            var sortiePopup = {
              title: 'Sortie ' + s.index,
              content: sortieContent,
              actions: [], overwriteActions: true
            };
            layer.add(new Graphic({
              geometry: new Point({ longitude: s.longitude, latitude: s.latitude }),
              symbol: new SimpleMarkerSymbol({ style: 'circle', size: 22, color: '#FC4231', outline: { color: 'white', width: 2 } }),
              popupTemplate: sortiePopup
            }));
            layer.add(new Graphic({
              geometry: new Point({ longitude: s.longitude, latitude: s.latitude }),
              symbol: new TextSymbol({ text: '' + s.index, color: 'white', font: { size: 10, weight: 'bold' }, yoffset: -1.5 })
            }));
          });

          // Fit view to all markers
          if (layer.graphics.length > 0) {
            view.goTo(layer.graphics.toArray()).then(function () {
              if (view.zoom > 19) view.zoom = 19;
              // Zoom out slightly to add breathing room
              view.scale = view.scale * 1.4;
            });
          }
        });
        });
      });
    });
  }

  getMarkerColor(available, total) {
    if (available === 0) return '#FC4231';
    let ratio = 1 - (available / total);
    if (ratio <= 0.25) return '#2DA86A';
    if (ratio <= 0.5) return '#FCC431';
    if (ratio <= 0.75) return '#FC7F31';
    return '#FC4231';
  }

  setParking() {
    jQuery('.parking-data').each(function (index, element) {
      let parkingEl = jQuery(element);
      let settings = jQuery(parkingEl).attr('data-settings');
      settings = JSON.parse(settings);

      for (let key in this.parkings) {
        if (this.parkings[key].id == settings.id) {
          let data = this.parkings[key];
          this.addRealtime(parkingEl, data, settings);
        }
      }

    }.bind(this));
  }

  setNeighborhood() {
    let neighborhoodEl = jQuery('.block-parking-neighborhood');
    if (neighborhoodEl.length > 0 && neighborhoodEl.is(':visible')) {
      jQuery('.parking-overview').each(function (index, element) {
        this.neighborhoods = this.neighborhoods.sort();
        let settings = jQuery(element).attr('data-settings');
        settings = JSON.parse(settings);

        for (let neighborhoodId in this.neighborhoods) {
          if (!this.neighborhoods.hasOwnProperty(neighborhoodId)) continue;

          let neighborhood = this.neighborhoods[neighborhoodId];
          let availability = 1 - (neighborhood.actuel / neighborhood.total);
          let neighborhoodTitle = neighborhood.title;
          let neighborhoodSlug = neighborhood.slug;
          let trend = this.getTrend(neighborhood.tendance);

          let progressWrapper = document.createElement('div');
          progressWrapper.dataset.neighborhood = neighborhoodTitle.toLowerCase();
          progressWrapper.className = 'parking-neighborhood-item col-desktop-3 col-tablet-3 col-mobile-6 col-small-6';

          progressWrapper.addEventListener('click', function (e) {
            e.preventDefault();
            if (this.sort != neighborhoodTitle) {
              this.setFilter(neighborhoodTitle);
              this.scrollTo('.controller-content', 1000);

            } else {
              this.resetFilter();
            }

          }.bind(this));

          let progressItem = document.createElement('div');
          progressItem.className = 'progress-item';

          let progressInfo = document.createElement('div');
          progressInfo.className = 'progress-infos';
          progressInfo.innerHTML = '<p class="neighborhood-current">' + neighborhood.actuel + '<svg class="trend ' + trend + '" width="12" height="11" xmlns="http://www.w3.org/2000/svg"><path d="M8.07 4.371L5.406 1.708A1 1 0 1 1 6.82.294l4.372 4.37a1 1 0 0 1 0 1.415l-4.372 4.37a1 1 0 0 1-1.414-1.415L8.07 6.371H1a1 1 0 1 1 0-2h7.07z" fill-rule="nonzero"/></svg></p>';
          progressInfo.innerHTML += '<p class="neighborhood-total">' + settings.text + ' /' + neighborhood.total + '</p>';

          let bar = new ProgressBar.Circle(progressItem, {
            strokeWidth: 4,
            easing: 'easeInOut',
            duration: 1400,
            color: this.getColor(availability),
            trailColor: '#F1F1F1',
            trailWidth: 4,
            svgStyle: null,
            text: {
              value: neighborhoodSlug == 'park-and-ride' ? settings.park_and_ride + '</br>' + neighborhoodTitle : settings.zone + '</br>' + neighborhoodTitle
            }
          });

          bar.trail.setAttribute('stroke-linecap', 'round');
          bar.path.setAttribute('stroke-linecap', 'round');

          jQuery(progressWrapper).append(progressItem);
          jQuery(progressWrapper).append(progressInfo);
          jQuery(element).append(progressWrapper);

          bar.animate(availability);
        }
      }.bind(this));
    }
  }

  setFilter(term = null) {

    let input = jQuery('#ParkingFilter');
    let items = jQuery(input.attr('data-items'));



    let titleEl = jQuery('#parking-title');
    let defaultTitle = jQuery(titleEl).attr('data-default-title');

    jQuery(input).on('input', function () {
      let searchTerm = jQuery.trim(this.value);

      jQuery('.parking-neighborhood-item').css({'opacity': 1});

      titleEl.text(defaultTitle);
      jQuery('.parking-neighborhood-item').each(function(index, element){
        if (term){
          if (jQuery(element).attr('data-neighborhood') == searchTerm.toLowerCase()){
            jQuery('.parking-neighborhood-item').css({'opacity': .5});
            jQuery(element).css({'opacity': 1});
            titleEl.text('Parkings ' + searchTerm);
          }
        }

      });

      searchTerm = searchTerm.toLowerCase();


      jQuery(items).each(function (i, el) {
        if (searchTerm.length < 1) {
          jQuery(el).show();
        } else {
          jQuery(el).toggle(jQuery(el).filter('[data-name*="' + searchTerm + '"], [data-neighborhood*="' + searchTerm + '"]').length > 0);
        }
      });
    });

    if (term) {
      jQuery(input).val(term);
      jQuery(input).trigger('input');
    } else {
      jQuery(input).val('');
      jQuery(input).trigger('input');
    }

    this.sort = term;
  }

  resetFilter() {
    this.setFilter();
    this.sort = null;
  }



  addRealtime(element, data, settings) {
    let progressLine = document.createElement('div');
    progressLine.className = 'progress-line';

    if (data.total > 0) {
      let availability = 1 - (data.actuel / data.total);
      let trend = this.getTrend(data.tendance);

      let currentEl = document.createElement('div');
      currentEl.className = 'parking-data-actuel';
      currentEl.innerHTML = data.actuel + '<svg class="trend ' + trend + '" width="12" height="11" xmlns="http://www.w3.org/2000/svg"><path d="M8.07 4.371L5.406 1.708A1 1 0 1 1 6.82.294l4.372 4.37a1 1 0 0 1 0 1.415l-4.372 4.37a1 1 0 0 1-1.414-1.415L8.07 6.371H1a1 1 0 1 1 0-2h7.07z" fill-rule="nonzero"/></svg>';

      let totalEl = document.createElement('div');
      totalEl.className = 'parking-data-total';
      totalEl.innerHTML = settings.empty_spaces + ' /' + data.total;

      let bar = new ProgressBar.Line(progressLine, {
        strokeWidth: 4,
        easing: 'easeInOut',
        duration: 1400,
        color: this.getColor(availability),
        trailColor: '#F1F1F1',
        trailWidth: 4,
        svgStyle: null
      });

      jQuery(element).append(currentEl);
      jQuery(element).append(totalEl);
      bar.animate(availability);
    } else {
      if (!data.ouvert) {
        progressLine.innerHTML = '<p class="no-data">' + settings.not_open + '</p>';
      } else {
        progressLine.innerHTML = '<p class="no-data">' + settings.no_data + '</p>';
      }
    }

    jQuery(element).prepend(progressLine);

  }

  getColor(value) {
    let color = null;

    if (value <= 0.25) {
      color = '#2DA86A';
    } else if (value <= 0.5) {
      color = '#FCC431';
    } else if (value <= 0.75) {
      color = '#FC7F31';
    } else if (value <= 1) {
      color = '#FC4231';
    }

    return color;
  }

  getTrend(value) {
    let direction = null;

    if (value < 0) {
      direction = 'down';
    } else if (value > 1) {
      direction = 'up';
    }

    return direction;

  }

  sortByDistance() {

    if (navigator.geolocation && this.geolocate) {

      this.geolocate.addEventListener('click', function () {
        let default_icon = jQuery(this.geolocate).find('.loader').html();
        jQuery(this.geolocate).find('.loader').html('<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"><path d="M.25 6a5.75 5.75 0 0 1 11.5 0h-1.5a4.25 4.25 0 1 0-8.5 0H.25z" fill="#1D3164" fill-rule="nonzero"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 6 6" to="360 6 6" dur="0.6s" repeatCount="indefinite"></animateTransform></path></svg>');

        navigator.geolocation.getCurrentPosition(function (position) {

          let items = jQuery('.parking-teaser-wide');

          jQuery(items).animate({'opacity': 0}, {
            complete: function () {
              items.sort(function (a, b) {
                let latitude_a = a.dataset.latitude;
                let longitude_a = a.dataset.longitude;
                let latitude_b = b.dataset.latitude;
                let longitude_b = b.dataset.longitude;

                let distance_a = this.getDistance(position.coords.latitude, position.coords.longitude, latitude_a, longitude_a);
                let distance_b = this.getDistance(position.coords.latitude, position.coords.longitude, latitude_b, longitude_b);

                return (distance_a - distance_b);
              }.bind(this));

              jQuery(items).detach().appendTo('.block-parking-list .block-content');

              jQuery(this.geolocate).find('.loader').html(default_icon);

              jQuery(items).animate({'opacity': 1});
            }.bind(this)
          });

        }.bind(this), function (positionError) {
          console.log(positionError);
          console.log('---');
          jQuery(this.geolocate).find('.loader').html(default_icon);
        }.bind(this));

      }.bind(this));

    } else {
      if (this.geolocate){
        this.geolocate.remove();
      }

    }

  }

  getDistance(lat1, lng1, lat2, lng2) {
    let earth_radius = 6378137;
    let rlo1 = this.deg2rad(lng1);
    let rla1 = this.deg2rad(lat1);
    let rlo2 = this.deg2rad(lng2);
    let rla2 = this.deg2rad(lat2);
    let dlo = (rlo2 - rlo1) / 2;
    let dla = (rla2 - rla1) / 2;
    let a = (Math.sin(dla) * Math.sin(dla)) + Math.cos(rla1) * Math.cos(rla2) * (Math.sin(dlo) * Math.sin(dlo));
    let d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return (earth_radius * d);
  }

  deg2rad(deg) {
    return deg * Math.PI / 180;
  }

  scrollTo(to, duration) {
    jQuery('html, body').animate({
      scrollTop: (jQuery(to).offset().top)
    },duration);
  }

}